import { Navigate } from "react-router-dom";
import { useSellerAuth } from "@/context/SellerAuthContext";
import { Loader2 } from "lucide-react";

export function SellerRoute({ children }) {
  const { seller, loading } = useSellerAuth();
  if (loading || seller === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <Loader2 className="h-8 w-8 animate-spin text-brand" />
      </div>
    );
  }
  if (!seller) return <Navigate to="/seller/login" replace />;
  if (seller.status !== "approved") return <Navigate to="/seller/pending" replace />;
  return children;
}
